<template>
    <div class="automation-wizard-overview-benefits">
        <p
            class="automation-wizard-overview-benefits__title typographies-paragraph-medium-semibold"
        >
            {{ translations.title }}
        </p>
        <div class="automation-wizard-overview-benefits__list">
            <template v-for="(benefit, index) in benefits">
                <div :key="index" class="automation-wizard-overview-benefits__list-item">
                    <CompassIcon
                        icon="success-circle-fill"
                        size="small"
                        class="automation-wizard-overview-benefits__icon"
                    />
                    <p
                        class="automation-wizard-overview-benefits__label typographies-paragraph-small"
                    >
                        {{ benefit }}
                    </p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        benefits: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            translations: {
                title: this.$t.__('automation.AutomationWizardOverviewBenefits.title'),
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-overview-benefits {
    display: flex;
    flex-direction: column;
    border-radius: var(--spacing-1);
    gap: var(--spacing-3);
    padding: var(--spacing-3);
    background: var(--colors-common-background-primary-subtle-alt);

    &__title {
        color: var(--colors-common-text-brand-secondary-blue);
        margin: 0;
    }
    &__list {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);
        &-item {
            display: flex;
            align-items: flex-start;
            gap: var(--spacing-0);
        }
    }
    &__icon {
        color: var(--colors-sellsy-brand-primary-600);
    }
    &__label {
        margin: 0;
        color: var(--colors-common-text-brand-secondary-blue);
    }
}
</style>
